import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  signal,
  viewChild
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslatePipe } from '@ngx-translate/core';

import { SvgIconComponent } from 'angular-svg-icon';
import { ImmomioFormFieldComponent } from '@immomio/ui/form';
import {
  injectNgControl,
  NoopValueAccessorDirective
} from '../../../../../directives/form/noop-value-accessor';

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.scss'],
  hostDirectives: [NoopValueAccessorDirective],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    SvgIconComponent,
    TranslatePipe,
    ImmomioFormFieldComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PasswordComponent {
  control = injectNgControl();
  readonly label = input<string>(undefined);
  readonly showLabel = input<true>(undefined);
  readonly showRequiredBox = input(false);
  readonly placeholder = input('');
  readonly passwordInput = viewChild<ElementRef>('inputElement');
  protected readonly boxVisible = signal(false);

  public getIcon(condition: boolean): string {
    return `/assets/images/icons/${
      condition ? 'icon-unverified.svg' : 'icon-bordered-check.svg'
    }`;
  }

  public showPassword(event: PointerEvent): void {
    event.preventDefault();
    const passwordInput = this.passwordInput();
    if (passwordInput.nativeElement.type === 'password') {
      passwordInput.nativeElement.type = 'text';
    } else {
      passwordInput.nativeElement.type = 'password';
    }
  }
}
